exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget[data-v-7cdeafaa]{margin-bottom:0}.widget-head[data-v-7cdeafaa]{border:1px solid #3540512b;background:#d7e3e5;color:#000;padding:0 20px}.panel-body[data-v-7cdeafaa]{background-color:#fff;border:1px solid #3540511f}.loading[data-v-7cdeafaa]{background-color:hsla(0,0%,100%,.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7cdeafaa","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Selector.vue
// module id = 14u5
// module chunks = 101